export default __webpack_public_path__ + "img/binla_book.8b22ef48.png";